import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

let t;

class LockedDialog extends React.Component {
    constructor(props) {
        super(props);
        t = props.t;
        this.state = {
            open: props.open,
        }
    }

    render() {
        return (

            /*
            Note that a fix for validateDOMNesting has been done here:

            If this error occurs while using Material UI <Typography> https://material-ui.com/api/typography/,
            then you can easily change the <p> to a <span> by changing the value of the component attribute of the <Typography> element :
            <Typography component={'span'} variant={'body2'}>

            https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
            */
            <Dialog
                fullScreen={false}
                open={this.props.open}
                onClose={() => {}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{t('session_ended')}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        {t('locked_dialog_message')}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

export default withMobileDialog()(LockedDialog);


// WEBPACK FOOTER //
// ./src/Components/LockedDialog.js